import Mesh from './Mesh'

class Scene extends Mesh {

  intro () {
    return new Promise((resolve, reject) => { resolve() })
  }

  outro () {
    return new Promise((resolve, reject) => { resolve() })
  }

}

export default Scene


// WEBPACK FOOTER //
// ./src/scripts/webgl/Scene.js